import { render } from "./LandingFooter.vue?vue&type=template&id=79bf97a8&scoped=true"
import script from "./LandingFooter.vue?vue&type=script&lang=js"
export * from "./LandingFooter.vue?vue&type=script&lang=js"

import "./LandingFooter.vue?vue&type=style&index=0&id=79bf97a8&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bf97a8"]])

export default __exports__